import { render } from "./IframeCovid.component.vue?vue&type=template&id=64a75b75"
import script from "./IframeCovid.component.vue?vue&type=script&lang=js"
export * from "./IframeCovid.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/iframe/IframeCovid.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64a75b75"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64a75b75', __exports__)) {
    console.log('reload')
    api.reload('64a75b75', __exports__)
  }
  
  module.hot.accept("./IframeCovid.component.vue?vue&type=template&id=64a75b75", () => {
    console.log('re-render')
    api.rerender('64a75b75', render)
  })

}


export default __exports__